export function Login() {
  return (
    <main className="flex min-h-dvh items-center justify-center bg-bg px-4 text-ink">
      <form className="w-full max-w-sm space-y-4">
        <div>
          <h1 className="font-mono text-3xl font-semibold text-bartlett">Faceoff</h1>
          <p className="mt-2 text-sm text-muted">Bartlett Hockey</p>
        </div>

        <label className="block space-y-2">
          <span className="text-sm font-semibold">Email</span>
          <input
            className="h-11 w-full rounded-control border border-border bg-white px-3 text-base outline-none focus:border-bartlett focus:ring-2 focus:ring-bartlett/10"
            type="email"
            autoComplete="email"
          />
        </label>

        <button
          className="h-11 w-full rounded-control bg-bartlett px-3 text-sm font-semibold text-white"
          type="submit"
        >
          Continue
        </button>
      </form>
    </main>
  );
}
